module.exports = __webpack_public_path__ + "img/icon4.e3a0ccda.png";